module.exports = __webpack_public_path__ + "static/media/us-gold-currency-logo-symbol.5bc15fda.png";